// extracted by mini-css-extract-plugin
module.exports = {"container":"FlagStatement_container__3Agx4","footer":"FlagStatement_footer__2dwQc"};